export default __webpack_public_path__ + "static/media/bf0a2111d8cc3c29.973cc6a11f9173942767526908047114.svg";